import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-insurance',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.scss']
})

export class InsuranceComponent {
  @Output() onInsuranceChange: EventEmitter<boolean> = new EventEmitter();

  handleChange(event) {
    this.onInsuranceChange.emit(event.value);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/order-summary/components/insurance/insurance.component.ts